const objective = (objective = null, action) => {
    switch (action.type) {
        case "SET_OBJECTIVE":
            return action.objective;
        default:
            return objective;
    }
};
export default objective;